import { render } from "./MemberPositionTag.vue?vue&type=template&id=26517d9b&scoped=true&ts=true&lang=pug"
import script from "./MemberPositionTag.vue?vue&type=script&lang=ts"
export * from "./MemberPositionTag.vue?vue&type=script&lang=ts"

import "./MemberPositionTag.vue?vue&type=style&index=0&id=26517d9b&scoped=true&lang=css"

import exportComponent from "/Users/lauriel/gitRepos_work/hero/hero_web_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26517d9b"]])

export default __exports__